module.exports = __webpack_public_path__ + "img/us-map-sample.7c998b20.png";